import React from 'react';
import { Modal } from 'react-bootstrap';
import { formatoDecimal } from "../../../../utilities/formatoNumeros";
import BigSpinner from '../../../General/BigSpinner';
import './LiquidacionDetalleModal.css';

export default function ModalDetallePercepciones({ show, onHide, percepciones = [], isLoading }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop="static"
            dialogClassName="liquidacion-detalle-modal"
            contentClassName="liquidacion-detalle-modal__content"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <span className="liquidacion-detalle-modal__title-icon liquidacion-detalle-modal__title-icon--percepciones" aria-hidden="true">
                        <i className="fa fa-percent" />
                    </span>
                    Detalle de Percepciones
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="liquidacion-detalle-modal__body-inner">
                    {isLoading ? (
                        <div className="d-flex justify-content-center py-4">
                            <BigSpinner label="Cargando percepciones..." />
                        </div>
                    ) : percepciones.length === 0 ? (
                        <div className="liquidacion-detalle-modal__empty">
                            No hay percepciones disponibles
                        </div>
                    ) : (
                        <div className="table-responsive liquidacion-detalle-modal__table-wrap">
                            <table className="table table-hover liquidacion-detalle-modal__table mb-0">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Régimen</th>
                                        <th>Alícuota (%)</th>
                                        <th>Monto</th>
                                        <th>Monto a Devolver</th>
                                        <th>Saldo</th>
                                        <th>Base Imponible</th>
                                        <th>Provincia</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {percepciones.map((item, idx) => (
                                        <tr key={item.id ?? idx}>
                                            <td>{item.id}</td>
                                            <td>{item.regimen}</td>
                                            <td>{item.alicuota}</td>
                                            <td>${formatoDecimal(item.monto)}</td>
                                            <td>${formatoDecimal(item.montoADevolver)}</td>
                                            <td>${formatoDecimal(item.saldo)}</td>
                                            <td>${formatoDecimal(item.baseImponible)}</td>
                                            <td>{item.provincia || '—'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="liquidacion-detalle-modal__btn-cerrar" onClick={onHide}>
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    );
}
